import { useRouter } from 'next/router';
import EfSpec from '@elem/ui/ef-spec';
import BannerA from './BannerA';
import BannerB from './BannerB';
import BannerC from './BannerC';
import BannerD from './BannerD';
import BannerE from './BannerE';
import BannerF from './BannerF';
import BannerG from './BannerG';
import BannerH from './BannerH';
import CardsAppA from './CardsAppA';
import CardsAppB from './CardsAppB';
import HighlightsA from './HighlightsA';
import ListA from './ListA';
import OtherA from './OtherA';
import OtherB from './OtherB';
import SectionA from './SectionA';
import SectionB from './SectionB';
import SectionC from './SectionC';
import SectionLRA from './SectionLRA';
import TabSectionA from './TabSectionA';
import TabSectionB from './TabSectionB';
import TC from './TC';

export default function Detail() {
    const { locale } = useRouter();
    return (
        <>
            <BannerA />
            <HighlightsA />
            <TabSectionA />
            <BannerB />
            <BannerC />
            <BannerD />
            <BannerE />
            <CardsAppB />
            <OtherA />
            <SectionA />
            <BannerF />
            <TabSectionB />
            <SectionLRA />
            <BannerG />
            <SectionB />
            <SectionC />
            <BannerH />
            <ListA />
            <CardsAppA />
            <OtherB />
            <EfSpec />
            {locale === 'us' && <TC />}
        </>
    );
}
